const ITEMS = [
    "Design Personalizado",
    "Experiência Responsiva",
    "Código Otimizado",
    "Navegação Intuitiva",
    "Estratégia de Conversão",
];

const Row = () => (
    <div className="flex gap-12 pr-12 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center gap-2 whitespace-nowrap">
                <span className="w-1.5 h-1.5 bg-[#2563eb] rounded-full" />
                {item}
            </span>
        ))}
    </div>
);

export const Marquee = () => {
    return (
        <div
            data-testid="marquee"
            aria-hidden="true"
            className="py-4 border-b border-[#1e2430] bg-[#0c1017] overflow-hidden"
        >
            <div className="mq-track code-font text-xs uppercase tracking-widest text-slate-400">
                <Row />
                <Row />
            </div>
        </div>
    );
};
